<div class="connect-test-section" clickOutside (clickOutside)="onClickOutside()">
  @if (isBookmarked) {
    <pdq-button
      label="Saved to Roadmap"
      icon="bookmark-filled"
      variant="dark"
      size="small"
      [fullWidth]="true"
      (onClick)="unsaveStrategy()">
    </pdq-button>
  } @else {
    <pdq-button
      label="Save Strategy"
      icon="bookmark"
      variant="tertiary"
      size="small"
      [fullWidth]="true"
      (onClick)="saveStrategy()">
    </pdq-button>
  }

  @if (connectedTest) {
    <div class="connected-test-card">
      <span class="test-name">{{ connectedTest.testName }}</span>
      <div class="connected-test-actions">
        @if (connectedTest.status) {
          <span class="test-status-badge" [ngClass]="'status--' + connectedTest.status">
            {{ connectedTest.status | titlecase }}
          </span>
        }
        <pdq-button icon="minus-circle" variant="ghost" size="small" (onClick)="disconnectTest()"></pdq-button>
      </div>
    </div>
  } @else {
    <pdq-button
      label="Connect a Test"
      icon="Plus"
      variant="tertiary"
      size="small"
      [fullWidth]="true"
      (onClick)="toggleDropdown()">
    </pdq-button>
  }

  @if (isDropdownOpen) {
    <div class="test-dropdown">
      <pdq-input size="medium" placeholder="Search tests..." [withIcon]="true" icon="search" [control]="searchControl">
      </pdq-input>

      @if (loading) {
        <div class="dropdown-loading">
          <p>Loading tests...</p>
        </div>
      } @else if (testGroups.length === 0) {
        <div class="dropdown-empty">
          <p>No tests found</p>
        </div>
      } @else {
        <div class="test-groups">
          @for (group of testGroups; track group.label) {
            <div class="test-group">
              <p class="test-group__label">{{ group.label }}</p>
              @for (test of group.tests; track test.testId) {
                <div class="test-option" (click)="selectTest(test)">
                  <span class="test-status-dot" [ngClass]="'dot--' + test.status"></span>
                  <span class="test-option__name">{{ test.testName }}</span>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
